<template>
    <div id="data-list-list-view">
      <vs-tabs v-model="tabIndex" class="padTop20">
        <vs-tab :label="item.label" v-for="item in vsTabsList" :key="item.id">
        <div class="flex search-wrap" :class="tabIndex == 1 ? 'flexEnd' : '' ">
          <template v-if="tabIndex == 0">
            <v-select v-model="categoryId" :options="options" :reduce="opt => opt.id"
                          placeholder="请选择分类" class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>
            <gc-cmp-vs-input v-model="filterText" class="filterInput marLeft16"
                          placeholder="请输入商品名称/编码/69码"/>
            <vs-button type="filled" size="small" @click.prevent="getTableData(1)" class="marLeft16">查询</vs-button>
          </template>
          <vs-button v-else-if="tabIndex!= 0 && filtering('price:priceDetailAdd')" @click="addNewGrade()">新增</vs-button>
        </div>
        <!-- 商品价格 -->
        <template  v-if="tabIndex == 0">
          <div id="priceTable"  class="priceTable con-tablex vs-table--content">
            <div class="vs-con-tbody vs-table--tbody ">
             <table :data="tableData" id="priceTable" ref="table" class="vs-table vs-table--tbody-table">
              <thead ref="thead" class="vs-table--thead">
                <vs-th class="data-th" style="min-width:50px">序号</vs-th>
                <vs-th class="data-th" style="min-width:180px">商品名称</vs-th>
                <vs-th class="data-th" style="min-width:100px">商品编码</vs-th>
                <vs-th class="data-th" style="min-width:120px">69码</vs-th>
                <vs-th class="data-th" style="min-width:100px">商品分类</vs-th>
                <!-- 商品价格等级需要动态生成表头 -->
                <vs-th v-for="extraTh in priceExtraTh" :key="extraTh">
                  {{extraTh}}
                </vs-th>
                <vs-th class="fixed-table-column th-back" style="min-width:50px">操作</vs-th>
              </thead>
              <tbody>
                <vs-tr :key="indextr" v-for="(tr, indextr) in tableData">
                  <vs-td>{{ indextr + 1 }}</vs-td>
                  <vs-td>{{ tr['goodsName'] }}</vs-td>
                  <vs-td>{{ tr['skuCode'] }}</vs-td>
                  <vs-td>{{ tr['barCode'] }}</vs-td>
                  <vs-td>{{ tr['goodsCategory'] }}</vs-td>
                  <!-- 商品价格管理需要动态生成表头 -->
                  <vs-td class="text-right" v-for="(extraTh,extraIndex) in priceExtraTh" :key="extraTh">
                    <template v-if="tr.editFlag">
                      <gc-cmp-vs-input v-model="tableData[indextr].priceList[extraTh]" maxlength="8" class="table-edit-input"
                                :autofocus ="extraIndex == 0 ? true : false"
                                aria-placeholder="123"
                                @input="validatePosNumber(true, indextr, extraTh)" />
                    </template>
                    <template v-else-if="tr.priceList[extraTh] > 0">
                      {{ tr.priceList[extraTh] | currencyFormat(2, true) }}
                    </template>
                    <template v-else>{{tr.priceList[extraTh] }}</template>
                  </vs-td>
                  <vs-td class="fixed-table-column white pointer">
                    <feather-icon v-if="tr.editFlag&&filtering('price:update')" icon="SaveIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary"
                                  @click.stop="modifyPrice(tr)" />
                    <feather-icon v-else-if="!tr.editFlag&&filtering('price:priceDetailUpdate')" icon="EditIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary"
                                  @click.stop="tr.editFlag = true" />
                  </vs-td>
                </vs-tr>
              </tbody>
            </table>
          </div>
          <div v-if="tableData.length == 0" class="vs-table--not-data">
            <img src="@/assets/images/commodity-sys/no-data.png" />
            <div class="nodata-text">暂无数据</div>
          </div>
          <!-- <gc-vs-pagination :total="pager.total" v-model="pager.page" :max="7"
                      :max-items="pager.size" :goto="true" class="marTop16"></gc-vs-pagination> -->
        </div>
          <gc-vs-pagination
            :pager="pager"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            ></gc-vs-pagination>
        </template>
        <!-- 价格等级 -->
        <vs-table v-if="tabIndex == 1" :data="gradeTableData">
          <template slot="thead">
            <vs-th>序号</vs-th>
            <vs-th>等级名称</vs-th>
            <vs-th>等级备注</vs-th>
            <vs-th>操作</vs-th>
          </template>
          <template slot-scope="{data}">
            <tbody v-if="data.length > 0">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ indextr + 1 }}</vs-td>
                <vs-td>
                  <template v-if="tr.editFlag">
                    <gc-cmp-vs-input maxlength="50"
                     @input="changeValue('priceName',indextr)"
                     v-model="data[indextr].priceName" autofocus="true"
                                  type="text" placeholder="等级名称"/>
                  </template>
                  <template v-else>{{tr.priceName}}</template>
                </vs-td>
                <vs-td>
                  <template v-if="tr.editFlag">
                    <gc-cmp-vs-input maxlength="50"
                    @input="changeValue('priceDescription',indextr)"  v-model="data[indextr].priceDescription"
                                  type="text" placeholder="等级备注"/>
                  </template>
                  <template v-else>{{tr.priceDescription}}</template>
                </vs-td>
                <vs-td>
                  <feather-icon v-if="tr.editFlag" icon="SaveIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary"
                                  @click.stop="modifyGradeDetail(tr)" />
                  <feather-icon v-else icon="EditIcon" svgClasses="w-5 h-5 stroke-current" class="text-primary"
                                  @click.stop="editGradeDetail(tr)" />
                </vs-td>
              </vs-tr>
            </tbody>
            <!-- <tbody v-else>
              暂无数据
            </tbody> -->
          </template>
        </vs-table>
        <gc-vs-pagination
             v-if="tabIndex == 1"
            :pager="pager"
            @handleSizeChange="priceSizeChange"
            @handleCurrentChange="priceCurrentChange"
            ></gc-vs-pagination>
      </vs-tab>
      </vs-tabs>
  </div>
</template>

<script>
  import GcCmpVsTable from "@/group-cloud/components/vsTable";
  import GcCmpVsInput from "@/group-cloud/components/vsInput";
  import {
    CommodityPriceApi
  } from "@/modules/server-api/commodity-sys/price-manage";
  import { $busErrorCode, getThreeCategory } from "@/modules/commodity-sys/common.js";
  import {CommodityCategoryApi} from "@/modules/server-api/commodity-sys/category-manage";
  export default {
    data(){
        return{
          tabIndex:0,
          filterText:"",
          categoryId: "", //分类
          allCategoryIds : [],
          vsTabsList:[
            {id: 'price', label: '商品价格'},
            {id: 'grade', label: '价格等级'}
          ],//tab标签页
          options:[],
          priceExtraTh : [], //动态表头
          tableData:[],
          gradeTableData:[],
          pager: {
            page: 1,
            size: 50,
            total: 0
          }
        }
    },
    mounted(){
      this.getGradeTableData();
      this.getCategoryOptions();
    },
    methods:{
      //查询商品价格:分类必须要有
      async getTableData(page){
         this.$vs.loading();
        this.pager.page = page || this.pager.page;

        let categoryParam = [];
        if(!this.categoryId || this.categoryId == ''){
          categoryParam = this.allCategoryIds;
        }else{
          categoryParam.push(this.categoryId);
        }
        if(categoryParam.length > 0){
          this.tableData = [];
          let resp = await CommodityPriceApi.getPriceList({
              "pageNum": this.pager.page,
              "pageSize": this.pager.size,
              "fuzzyKeyword": this.filterText,
              "categoryId": categoryParam
          });
          if(resp.succ == 0 || resp.code == $busErrorCode){
            this.$notifyError(resp.error);
          }else{
            let resData = resp.result.list;
            if(resData.length > 0){
              resData.map(item =>{
                item.editFlag = false;
                //将价格为-1的改为''
                this.priceExtraTh.map(ex =>{
                  if(item.priceList[ex] == -1){
                      item.priceList[ex] = '';
                  }
                });
                this.tableData.push(item);
              })
            }
            //更新分页参数
           // this.pager.total = Math.ceil(resp.result.totalCount / this.pager.size);
           this.pager.total = resp.result.totalCount;
          }
           this.$vs.loading.close();
        }
      },
      //修改商品价格
      async modifyPrice(row){
        let validateFlag = true;
        if(this.priceExtraTh.length > 0){
          let skuCode = row.skuCode;
          this.priceExtraTh.map(async (item, index) =>{
            if(validateFlag && row.priceList[item]){
              validateFlag = this.validatePosNumber(false, row.priceList[item]);
            }
          });
          if(validateFlag){
            //校验通过后保存
            this.priceExtraTh.map(async (item, index) =>{
              if(row.priceList[item]){
                let resp = await CommodityPriceApi.modifyGoodsPrice({
                    "skuCode": skuCode,
                    "priceName": item,
                    "price" : row.priceList[item]
                });
                if(resp.succ == 0 || resp.code == $busErrorCode){
                  this.$notifyError(resp.error);
                }
                //最后一个需要刷新页面
                if(index == this.priceExtraTh.length -1){
                  this.getTableData();
                }

              }else if(index == this.priceExtraTh.length -1){
                this.getTableData();
              }
            });
          }
        }
      },
      //查询价格等级
      async getGradeTableData(page){
        // let resp = await CommodityPriceApi.getGradeList({
        //       "pageNo": this.pager.page,
        //       "pageSize": this.pager.size,
        //       data:{
        //         suggest:this.filterText,
        //         type: this.vsTabsList[this.tabIndex].id //仓位类型
        //       }
        // });
         this.$vs.loading();
         this.pager.page = page || this.pager.page;
        let resp = await CommodityPriceApi.getGradeList({
            "pageNum": this.pager.page,
            "pageSize": this.pager.size,
        });
        if(resp.succ == 0 || resp.code == $busErrorCode){
          this.$notifyError(resp.error);
        }else{
          let resData = resp.result.list;
          this.gradeTableData = [];
          if(resData.length > 0){
            this.priceExtraTh = [];
            resData.map(item =>{
              this.priceExtraTh.push(item.priceName);
              //价格等级页面数据处理
              if(this.tabIndex == 1){
                item.editFlag = false;
              }
              this.gradeTableData.push(item);
            })
          }
          this.pager.total = resp.result.totalCount;
        }
         this.$vs.loading.close();
      },
      //新增价格等级
      addNewGrade(){
        this.gradeTableData.push({
          priceName: '',
          priceDescription: '',
          editFlag: true
        })
      },
      // priceNameChange(row){
      //   console.log('gradeTableData',this.gradeTableData)
      //   // let priceData = this.gradeTableData.findIndex(name => name.priceName == row.priceName);
      //   // if (priceData != -1) {
      //   //    this.$notifyError("当前等级名称已存在");
      //   // }
      // },
      // 编辑
      editGradeDetail(row){
        console.log(row)
        console.log('gradeTableData',this.gradeTableData)
        this.gradeTableData.map(item => {
          if(item.id != row.id) {
            item.editFlag = false;
          }
        })
          row.editFlag = true
      },
      //修改价格等级
     async modifyGradeDetail(row){
        console.log(row);
        let param = {};
        if(row.id && row.id != ''){
          param.id = row.id;
        }
        param.priceName = row.priceName;
        param.priceDescription = row.priceDescription;
        this.$vs.loading();
        let resp = await CommodityPriceApi.modifyGradeDetail(param);
        if(resp.succ == 0 || resp.code == $busErrorCode){
          this.$vs.loading.close();
          this.$notifyError(resp.error);
        }else{
          this.$vs.loading.close();
          this.$notifySuccess("保存成功");
          //刷新页面
          this.getGradeTableData();
        }
      },
      //获取分类
      async getCategoryOptions(){
          //获取分类数据
          let resCategoryList = await CommodityCategoryApi.getCategoryList({});
          let resList = resCategoryList.result;
          if(resList){
              //获取三级分类
              let finalList = [];
              resList.map((item) =>{
                  let child = getThreeCategory(item);
                  if(child && child.length > 0){
                      child.map((item) => finalList.push(item));
                  }
              });
              this.allCategoryIds = [];
              finalList && finalList.map((item) =>{
                  let obj ={};
                  obj.id = item.id;
                  obj.label = item.categoryName;
                  this.allCategoryIds.push(item.id);
                  this.options.push(obj);
              });
              //加载数据
              this.getTableData();
          }
      },
      //校验字符：最多输入25个中文，或者50个英文
      changeValue(attr,indextr) {
        console.log(111)
        let value = this.gradeTableData[indextr][attr]; //校验的字段
        // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
        let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/;
        let maxLimitStr = 25; //25个汉字
        let pass = true;
        let substringStr = "";
        let length = 0;
        let strArr = value.split("");
        strArr.map((str) => {
          if (pass) {
            if (cnReg.test(str)) {
              //中文
              length++;
            } else {
              //英文
              length += 0.5;
            }
            //大于最大限制的时候
            if (length > maxLimitStr) {
              pass = false;
              this.$notifyError(
                "文字长度已超出最大值，最大值为" + maxLimitStr * 2 + "个字符",
              );
              //将校验的字符截取返回
              this.gradeTableData[indextr][attr] = substringStr;
            } else {
              substringStr += str;
            }
          }
        });
        return pass;
        // let mat = value.match(cnReg)
        // if (mat) {
        //     length = (mat.length + (value.length - mat.length) * 0.5)
        //     return length
        // } else {
        //     return value.length * 0.5
        // }
      },
      //校验是否是正数，最多两位小数
      validatePosNumber(tableDataFlag, index, extraTh){
        let currNum = tableDataFlag ? this.tableData[index].priceList[extraTh] : index;
        let rule = /^\d+(\.\d{0,2})?$/;
        let flag = true;
        if(!rule.test(currNum)){
          flag = false;
          if(tableDataFlag && (currNum < 0 || isNaN(currNum))){
            this.$set(this.tableData[index].priceList, extraTh, '');
          }
          this.$forceUpdate();
          this.$notifyError("请输入正数并且最多2位小数的数字");
        }
        return flag;
      },
      //更改每页条数
      handleSizeChange(val){
        this.pager.size = val;
        this.getTableData();
      },
      handleCurrentChange(val){
        this.pager.page = val;
        this.getTableData();
      },
      //更改价格每页条数
      priceSizeChange(val){
        this.pager.size = val;
        this.getGradeTableData();
      },
      priceCurrentChange(val){
        this.pager.page = val;
        this.getGradeTableData();
      }
    },
    components: {
      GcCmpVsTable,GcCmpVsInput
    },
    watch:{
      tabIndex(value){
        this.filterText = "";
        this.pager.page = 1;
        this.categoryId = "";
        if(value == 0){//商品价格管理
          this.tableData = [];
          this.getTableData()
        }else{//价格等级
          this.gradeTableData = [];
          this.getGradeTableData();
        }
      }
      // ,
      // //分页
      // "pager.page"(){
      //   this.getTableData();
      // }
    }
  }
</script>

<style lang="scss" scoped>
 @import '@/modules/commodity-sys/commodity.scss';
 .search-wrap{
   margin-top: 20px;
   margin-bottom: 20px;
 }
</style>
<style lang="scss">
 .priceTable .vs-table thead th {
     min-width: 165px;
   }
 .priceTable .vs-table thead th .vs-table-text{
     float: right;
   }
  .priceTable .vs-table thead th.data-th .vs-table-text{
     float: left;
   }
</style>
